export default "__VITE_ASSET__B1YxT$Qg__"